<template>
  <div>
    <TableAggregationsToolbar
      v-if="!isInitialLoading && aggregations"
      :aggregations="aggregations"
    ></TableAggregationsToolbar>
    <b-skeleton v-if="isInitialLoading" width="300px" height="24px"></b-skeleton>
  </div>
</template>

<script>
import TableAggregationsToolbar from '@/components/common/table-aggregations-toolbar';
import apiService from '@/core/common/services/api.service';
import { File, Check, Ban, Users } from 'lucide-vue';

export default {
  components: { TableAggregationsToolbar },
  props: {
    isParentLoading: {
      type: Boolean,
    },
  },
  data() {
    return {
      isLoading: true,
      isInitialLoading: true,
      aggregations: null,
    };
  },
  watch: {
    isParentLoading: {
      immediate: true,
      handler: async function (isParentLoading) {
        if (isParentLoading) {
          const odataAggregate = await this.getAggregationsByFilter();
          const transformedAggregate = this.transformAggregateDate(odataAggregate);
          this.aggregations = [
            {
              data: transformedAggregate.New || '-',
              title: this.$t('COMMON.NEU'),
              iconComponent: File,
              iconColor: '#3699FF',
            },
            {
              data: transformedAggregate.Merged || '-',
              title: this.$t('DUBLETTEN.CONFIRMATION.MERGED'),
              iconComponent: Check,
              iconColor: '#1BC5BD',
            },
            {
              data: transformedAggregate.Declined || '-',
              title: this.$t('DUBLETTEN.CONFIRMATION.DECLINED'),
              iconComponent: Ban,
              iconColor: '#F64E60',
            },
            {
              data: transformedAggregate.total || '-',
              title: this.$t('COMMON.INSGESAMT'),
              iconComponent: Users,
              iconColor: '#B5B5C3',
            },
          ];
        }
      },
    },
  },
  methods: {
    async getAggregationsByFilter() {
      this.isLoading = true;
      return apiService
        .get(
          'AgenturDuplicateSuggestion?$apply=groupby(((state)),aggregate($count%20as%20$count))&$count=true'
        )
        .then(response => {
          return response.data.result.value;
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.isLoading = false;
          this.isInitialLoading = false;
        });
    },
    transformAggregateDate(data) {
      return data.reduce(
        (acc, cur) => {
          if (!acc.hasOwnProperty(cur.state)) {
            acc[cur.state] = cur.$count;
            acc.total += cur.$count;
          }
          return acc;
        },
        { total: 0 }
      );
    },
  },
};
</script>
